import { PlannerDynamicSidebarContentType } from "@lifeat/shared/planner/PlannerTypes";
import { effect, signal } from "@preact/signals-react";
import { PlannerMainContent } from "./PlannerTypes";

export const mainContent$ = signal<PlannerMainContent>("task-board");
export const dynamicSidebarContent$ = signal<PlannerDynamicSidebarContentType>("task-list");
export const filteringSidebarOpen$ = signal(true);
export const viewingDate$ = signal(new Date());
export const firstVisibleDate$ = signal(new Date());

effect(() => {
    if (mainContent$.value === "calendar") {
        // If the dynamic sidebar is showing the calendar day view, we want
        // to change it if the main content changes to the calendar week view.
        if (dynamicSidebarContent$.value === "calendar-day") {
            dynamicSidebarContent$.value = "task-list";
        }
    }
    // Close the filtering sidebar on anything other than the task board.
    filteringSidebarOpen$.value = mainContent$.value === "task-board";
});
